// Compute ISO start/end from a date-range selection used across the app.
export function computeRange(range) {
  if (!range || !range.key || range.key === "all") return {};
  const iso = (d) => d.toISOString().slice(0, 19);
  const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };
  const endOfDay = (d) => { const x = new Date(d); x.setHours(23, 59, 59, 999); return x; };
  const now = new Date();
  const dayIdx = (now.getDay() + 6) % 7; // Monday = 0
  let start, end;
  switch (range.key) {
    case "today": start = startOfDay(now); end = endOfDay(now); break;
    case "yesterday": { const y = new Date(Date.now() - 86400000); start = startOfDay(y); end = endOfDay(y); break; }
    case "this_week": start = startOfDay(new Date(Date.now() - dayIdx * 86400000)); end = endOfDay(now); break;
    case "last_week": {
      const thisMon = startOfDay(new Date(Date.now() - dayIdx * 86400000));
      end = new Date(thisMon.getTime() - 1);
      start = startOfDay(new Date(thisMon.getTime() - 7 * 86400000));
      break;
    }
    case "this_month": start = startOfDay(new Date(now.getFullYear(), now.getMonth(), 1)); end = endOfDay(now); break;
    case "last_month":
      start = startOfDay(new Date(now.getFullYear(), now.getMonth() - 1, 1));
      end = endOfDay(new Date(now.getFullYear(), now.getMonth(), 0));
      break;
    case "7": start = startOfDay(new Date(Date.now() - 7 * 86400000)); end = endOfDay(now); break;
    case "30": start = startOfDay(new Date(Date.now() - 30 * 86400000)); end = endOfDay(now); break;
    case "90": start = startOfDay(new Date(Date.now() - 90 * 86400000)); end = endOfDay(now); break;
    case "custom":
      if (range.start && range.end) { start = startOfDay(new Date(range.start)); end = endOfDay(new Date(range.end)); }
      else return {};
      break;
    default: return {};
  }
  return { start: iso(start), end: iso(end) };
}

export const RANGE_OPTIONS = [
  { value: "all", label: "All time" },
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "this_week", label: "This Week" },
  { value: "last_week", label: "Last Week" },
  { value: "this_month", label: "This Month" },
  { value: "last_month", label: "Last Month" },
  { value: "7", label: "Last 7 days" },
  { value: "30", label: "Last 30 days" },
  { value: "90", label: "Last quarter" },
  { value: "custom", label: "Custom range" },
];
